import { render, staticRenderFns } from "./MfaRecoveryRequired.vue?vue&type=template&id=27fff7c6&scoped=true&"
import script from "./MfaRecoveryRequired.vue?vue&type=script&lang=js&"
export * from "./MfaRecoveryRequired.vue?vue&type=script&lang=js&"
import style0 from "./MfaRecoveryRequired.vue?vue&type=style&index=0&id=27fff7c6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27fff7c6",
  null
  
)

export default component.exports